import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var __privateMethod = function __privateMethod(obj, member, method) {
  __accessCheck(obj, member, "access private method");

  return method;
};

var _mediaController, _isInputTarget, _onFocusIn, _onFocusOut, _enableUserEvents, enableUserEvents_fn, _disableUserEvents, disableUserEvents_fn, _handlePointerDown, handlePointerDown_fn, _handlePointerEnter, handlePointerEnter_fn, _handlePointerUp, handlePointerUp_fn, _handlePointerLeave, handlePointerLeave_fn, _handlePointerMove, handlePointerMove_fn;

import { MediaStateReceiverAttributes } from "./constants.js";
import { globalThis, document } from "./utils/server-safe-globals.js";
import { getOrInsertCSSRule } from "./utils/element-utils.js";
var template = document.createElement("template");
template.innerHTML = "\n  <style>\n    :host {\n      --_focus-box-shadow: var(--media-focus-box-shadow, inset 0 0 0 2px rgb(27 127 204 / .9));\n      --_media-range-padding: var(--media-range-padding, var(--media-control-padding, 10px));\n\n      box-shadow: var(--_focus-visible-box-shadow, none);\n      background: var(--media-control-background, var(--media-secondary-color, rgb(20 20 30 / .7)));\n      height: calc(var(--media-control-height, 24px) + 2 * var(--_media-range-padding));\n      display: inline-flex;\n      align-items: center;\n      ".concat("\n      vertical-align: middle;\n      box-sizing: border-box;\n      position: relative;\n      width: 100px;\n      transition: background .15s linear;\n      cursor: pointer;\n      pointer-events: auto;\n      touch-action: none; ", "\n      z-index: 1; ", "\n    }\n\n    ", "\n    input[type=range]:focus {\n      outline: 0;\n    }\n    input[type=range]:focus::-webkit-slider-runnable-track {\n      outline: 0;\n    }\n\n    :host(:hover) {\n      background: var(--media-control-hover-background, rgb(50 50 70 / .7));\n    }\n\n    #leftgap {\n      padding-left: var(--media-range-padding-left, var(--_media-range-padding));\n    }\n\n    #rightgap {\n      padding-right: var(--media-range-padding-right, var(--_media-range-padding));\n    }\n\n    #container {\n      ", "\n      width: var(--media-range-track-width, 100%);\n      transform: translate(var(--media-range-track-translate-x, 0px), var(--media-range-track-translate-y, 0px));\n      position: relative;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      min-width: 40px;\n    }\n\n    #range {\n      ", "\n      display: var(--media-time-range-hover-display, block);\n      bottom: var(--media-time-range-hover-bottom, -7px);\n      height: var(--media-time-range-hover-height, max(100% + 7px, 25px));\n      width: 100%;\n      position: absolute;\n      cursor: pointer;\n\n      -webkit-appearance: none; ", "\n      -webkit-tap-highlight-color: transparent;\n      background: transparent; ", "\n      margin: 0;\n      z-index: 1;\n    }\n\n    @media (hover: hover) {\n      #range {\n        bottom: var(--media-time-range-hover-bottom, -5px);\n        height: var(--media-time-range-hover-height, max(100% + 5px, 20px));\n      }\n    }\n\n    ", "\n    ", "\n    #range::-webkit-slider-thumb {\n      -webkit-appearance: none;\n      background: transparent;\n      width: .1px;\n      height: .1px;\n    }\n\n    ", "\n    #range::-moz-range-thumb {\n      background: transparent;\n      border: transparent;\n      width: .1px;\n      height: .1px;\n    }\n\n    #appearance {\n      height: var(--media-range-track-height, 4px);\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      width: 100%;\n      position: absolute;\n    }\n\n    #background,\n    #track {\n      border-radius: var(--media-range-track-border-radius, 1px);\n      position: absolute;\n      width: 100%;\n      height: 100%;\n    }\n\n    #background {\n      background: var(--media-range-track-background, rgb(255 255 255 / .2));\n      backdrop-filter: var(--media-range-track-background-backdrop-filter);\n    }\n\n    #track {\n      border: var(--media-range-track-border, none);\n      outline: var(--media-range-track-outline);\n      outline-offset: var(--media-range-track-outline-offset);\n      backdrop-filter: var(--media-range-track-backdrop-filter);\n      box-shadow: var(--media-range-track-box-shadow, none);\n      overflow: hidden;\n    }\n\n    #progress {\n      background: var(--media-range-bar-color, var(--media-primary-color, rgb(238 238 238)));\n      border-radius: var(--media-range-track-border-radius, 1px);\n      transition: var(--media-range-track-transition);\n      position: absolute;\n      height: 100%;\n    }\n\n    #highlight {\n      border-radius: var(--media-range-track-border-radius, 1px);\n      position: absolute;\n      height: 100%;\n    }\n\n    #pointer {\n      background: var(--media-range-track-pointer-background);\n      border-right: var(--media-range-track-pointer-border-right);\n      border-radius: var(--media-range-track-border-radius, 1px);\n      transition: visibility .25s, opacity .25s;\n      visibility: hidden;\n      opacity: 0;\n      position: absolute;\n      height: 100%;\n    }\n\n    :host(:hover) #pointer {\n      transition: visibility .5s, opacity .5s;\n      visibility: visible;\n      opacity: 1;\n    }\n\n    #thumb {\n      width: var(--media-range-thumb-width, 10px);\n      height: var(--media-range-thumb-height, 10px);\n      margin-left: calc(var(--media-range-thumb-width, 10px) / -2);\n      border: var(--media-range-thumb-border, none);\n      border-radius: var(--media-range-thumb-border-radius, 10px);\n      background: var(--media-range-thumb-background, var(--media-primary-color, rgb(238 238 238)));\n      box-shadow: var(--media-range-thumb-box-shadow, 1px 1px 1px transparent);\n      transition: var(--media-range-thumb-transition);\n      transform: var(--media-range-thumb-transform, none);\n      opacity: var(--media-range-thumb-opacity, 1);\n      position: absolute;\n      left: 0;\n      cursor: pointer;\n    }\n\n    :host([disabled]) #thumb {\n      background-color: #777;\n    }\n  </style>\n  <div id=\"leftgap\"></div>\n  <div id=\"container\">\n    <div id=\"appearance\">\n      <div id=\"background\"></div>\n      <div id=\"track\">\n        <div id=\"highlight\"></div>\n        <div id=\"pointer\"></div>\n        <div id=\"progress\"></div>\n      </div>\n      <div id=\"thumb\"></div>\n    </div>\n    <input id=\"range\" type=\"range\" min=\"0\" max=\"1\" step=\"any\" value=\"0\">\n  </div>\n  <div id=\"rightgap\"></div>\n");

var MediaChromeRange = /*#__PURE__*/function (_globalThis$HTMLEleme) {
  _inherits(MediaChromeRange, _globalThis$HTMLEleme);

  var _super = _createSuper(MediaChromeRange);

  function MediaChromeRange() {
    var _this;

    _classCallCheck(this, MediaChromeRange);

    _this = _super.call(this);

    __privateAdd(_assertThisInitialized(_this), _enableUserEvents);

    __privateAdd(_assertThisInitialized(_this), _disableUserEvents);

    __privateAdd(_assertThisInitialized(_this), _handlePointerDown);

    __privateAdd(_assertThisInitialized(_this), _handlePointerEnter);

    __privateAdd(_assertThisInitialized(_this), _handlePointerUp);

    __privateAdd(_assertThisInitialized(_this), _handlePointerLeave);

    __privateAdd(_assertThisInitialized(_this), _handlePointerMove);

    __privateAdd(_assertThisInitialized(_this), _mediaController, void 0);

    __privateAdd(_assertThisInitialized(_this), _isInputTarget, void 0);

    __privateAdd(_assertThisInitialized(_this), _onFocusIn, function () {
      if (_this.range.matches(":focus-visible")) {
        var _getOrInsertCSSRule = getOrInsertCSSRule(_this.shadowRoot, ":host"),
            _style = _getOrInsertCSSRule.style;

        _style.setProperty("--_focus-visible-box-shadow", "var(--_focus-box-shadow)");
      }
    });

    __privateAdd(_assertThisInitialized(_this), _onFocusOut, function () {
      var _getOrInsertCSSRule2 = getOrInsertCSSRule(_this.shadowRoot, ":host"),
          style = _getOrInsertCSSRule2.style;

      style.removeProperty("--_focus-visible-box-shadow");
    });

    if (!_this.shadowRoot) {
      _this.attachShadow({
        mode: "open"
      });

      _this.shadowRoot.appendChild(template.content.cloneNode(true));
    }

    var _getOrInsertCSSRule3 = getOrInsertCSSRule(_this.shadowRoot, ":host"),
        style = _getOrInsertCSSRule3.style;

    style.setProperty("display", "var(--media-control-display, var(--".concat(_this.localName, "-display, inline-flex))"));
    _this.container = _this.shadowRoot.querySelector("#container");
    _this.range = _this.shadowRoot.querySelector("#range");
    return _this;
  }

  _createClass(MediaChromeRange, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      var _a, _b, _c, _d, _e;

      if (attrName === MediaStateReceiverAttributes.MEDIA_CONTROLLER) {
        if (oldValue) {
          (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);

          __privateSet(this, _mediaController, null);
        }

        if (newValue && this.isConnected) {
          __privateSet(this, _mediaController, (_c = this.getRootNode()) == null ? void 0 : _c.getElementById(newValue));

          (_e = (_d = __privateGet(this, _mediaController)) == null ? void 0 : _d.associateElement) == null ? void 0 : _e.call(_d, this);
        }
      } else if (attrName === "disabled" || attrName === "aria-disabled" && oldValue !== newValue) {
        if (newValue == null) {
          this.range.removeAttribute(attrName);

          __privateMethod(this, _enableUserEvents, enableUserEvents_fn).call(this);
        } else {
          this.range.setAttribute(attrName, newValue);

          __privateMethod(this, _disableUserEvents, disableUserEvents_fn).call(this);
        }
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _a, _b, _c;

      var mediaControllerId = this.getAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER);

      if (mediaControllerId) {
        __privateSet(this, _mediaController, (_a = this.getRootNode()) == null ? void 0 : _a.getElementById(mediaControllerId));

        (_c = (_b = __privateGet(this, _mediaController)) == null ? void 0 : _b.associateElement) == null ? void 0 : _c.call(_b, this);
      }

      this.updateBar();
      this.shadowRoot.addEventListener("focusin", __privateGet(this, _onFocusIn));
      this.shadowRoot.addEventListener("focusout", __privateGet(this, _onFocusOut));

      __privateMethod(this, _enableUserEvents, enableUserEvents_fn).call(this);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _a, _b;

      __privateMethod(this, _disableUserEvents, disableUserEvents_fn).call(this);

      (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);

      __privateSet(this, _mediaController, null);

      this.shadowRoot.removeEventListener("focusin", __privateGet(this, _onFocusIn));
      this.shadowRoot.removeEventListener("focusout", __privateGet(this, _onFocusOut));
    }
  }, {
    key: "updatePointerBar",
    value: function updatePointerBar(evt) {
      var rangeRect = this.range.getBoundingClientRect();
      var mousePercent = (evt.clientX - rangeRect.left) / rangeRect.width;
      mousePercent = Math.max(0, Math.min(1, mousePercent)) * 100;

      var _getOrInsertCSSRule4 = getOrInsertCSSRule(this.shadowRoot, "#pointer"),
          style = _getOrInsertCSSRule4.style;

      style.setProperty("width", "".concat(mousePercent, "%"));
    }
  }, {
    key: "updateBar",
    value: function updateBar() {
      var rangePercent = this.range.valueAsNumber * 100;
      var progressRule = getOrInsertCSSRule(this.shadowRoot, "#progress");
      var thumbRule = getOrInsertCSSRule(this.shadowRoot, "#thumb");
      progressRule.style.setProperty("width", "".concat(rangePercent, "%"));
      thumbRule.style.setProperty("left", "".concat(rangePercent, "%"));
    }
  }, {
    key: "dragging",
    get: function get() {
      return this.hasAttribute("dragging");
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(evt) {
      switch (evt.type) {
        case "input":
          this.updateBar();
          break;

        case "pointerenter":
          __privateMethod(this, _handlePointerEnter, handlePointerEnter_fn).call(this, evt);

          break;

        case "pointerdown":
          __privateMethod(this, _handlePointerDown, handlePointerDown_fn).call(this, evt);

          break;

        case "pointermove":
          __privateMethod(this, _handlePointerMove, handlePointerMove_fn).call(this, evt);

          break;

        case "pointerup":
          __privateMethod(this, _handlePointerUp, handlePointerUp_fn).call(this);

          break;

        case "pointerleave":
          __privateMethod(this, _handlePointerLeave, handlePointerLeave_fn).call(this);

          break;
      }
    }
  }, {
    key: "keysUsed",
    get: function get() {
      return ["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft"];
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["disabled", "aria-disabled", MediaStateReceiverAttributes.MEDIA_CONTROLLER];
    }
  }]);

  return MediaChromeRange;
}(globalThis.HTMLElement);

_mediaController = new WeakMap();
_isInputTarget = new WeakMap();
_onFocusIn = new WeakMap();
_onFocusOut = new WeakMap();
_enableUserEvents = new WeakSet();

enableUserEvents_fn = function enableUserEvents_fn() {
  if (this.hasAttribute("disabled")) return;
  this.addEventListener("input", this);
  this.addEventListener("pointerdown", this);
  this.addEventListener("pointerenter", this);
};

_disableUserEvents = new WeakSet();

disableUserEvents_fn = function disableUserEvents_fn() {
  var _a, _b;

  this.removeEventListener("input", this);
  this.removeEventListener("pointerdown", this);
  this.removeEventListener("pointerenter", this);
  (_a = globalThis.window) == null ? void 0 : _a.removeEventListener("pointerup", this);
  (_b = globalThis.window) == null ? void 0 : _b.removeEventListener("pointermove", this);
};

_handlePointerDown = new WeakSet();

handlePointerDown_fn = function handlePointerDown_fn(evt) {
  var _a;

  __privateSet(this, _isInputTarget, evt.composedPath().includes(this.range));

  (_a = globalThis.window) == null ? void 0 : _a.addEventListener("pointerup", this);
};

_handlePointerEnter = new WeakSet();

handlePointerEnter_fn = function handlePointerEnter_fn(evt) {
  var _a;

  if (evt.pointerType !== "mouse") __privateMethod(this, _handlePointerDown, handlePointerDown_fn).call(this, evt);
  this.addEventListener("pointerleave", this);
  (_a = globalThis.window) == null ? void 0 : _a.addEventListener("pointermove", this);
};

_handlePointerUp = new WeakSet();

handlePointerUp_fn = function handlePointerUp_fn() {
  var _a;

  (_a = globalThis.window) == null ? void 0 : _a.removeEventListener("pointerup", this);
  this.toggleAttribute("dragging", false);
  this.range.disabled = this.hasAttribute("disabled");
};

_handlePointerLeave = new WeakSet();

handlePointerLeave_fn = function handlePointerLeave_fn() {
  var _a;

  this.removeEventListener("pointerleave", this);
  (_a = globalThis.window) == null ? void 0 : _a.removeEventListener("pointermove", this);
  this.toggleAttribute("dragging", false);
  this.range.disabled = this.hasAttribute("disabled");
};

_handlePointerMove = new WeakSet();

handlePointerMove_fn = function handlePointerMove_fn(evt) {
  this.toggleAttribute("dragging", evt.buttons === 1 || evt.pointerType !== "mouse");
  this.updatePointerBar(evt);

  if (this.dragging && (evt.pointerType !== "mouse" || !__privateGet(this, _isInputTarget))) {
    this.range.disabled = true;
    var rangeRect = this.range.getBoundingClientRect();
    var pointerRatio = (evt.clientX - rangeRect.left) / rangeRect.width;
    pointerRatio = Math.max(0, Math.min(1, pointerRatio));
    this.range.valueAsNumber = pointerRatio;
    this.range.dispatchEvent(new Event("input", {
      bubbles: true,
      composed: true
    }));
  }
};

if (!globalThis.customElements.get("media-chrome-range")) {
  globalThis.customElements.define("media-chrome-range", MediaChromeRange);
}

var media_chrome_range_default = MediaChromeRange;
export { MediaChromeRange, media_chrome_range_default as default };